import Range from './src/range.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToRange: SFCWithInstall<typeof Range> = withInstall(Range)

export * from './src/instance'
